
const units = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
];
const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
];
const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
];
const thousands = ["", "Thousand", "Lakh", "Crore"];

export
    const convertAmountToWords = (num) => {
        if (num === 0) return "Zero";

        let word = "";
        let place = 0;

        const getTwoDigitWords = (n) => {
            if (n < 10) return units[n];
            if (n < 20) return teens[n - 10];
            return tens[Math.floor(n / 10)] + (n % 10 ? " " + units[n % 10] : "");
        };

        const getThreeDigitWords = (n) => {
            if (n === 0) return "";
            if (n < 100) return getTwoDigitWords(n);
            return (
                units[Math.floor(n / 100)] +
                " Hundred" +
                (n % 100 ? " " + getTwoDigitWords(n % 100) : "")
            );
        };

        while (num > 0) {
            let chunk = num % 1000; // Extract last three digits
            if (place === 0) {
                // Handle hundreds, tens, and units place (last three digits)
                word = getThreeDigitWords(chunk) + (word ? " " + word : "");
            } else {
                // Handle thousands, lakhs, crores
                const higherWord = getThreeDigitWords(chunk);
                if (higherWord) {
                    word =
                        higherWord +
                        " " +
                        thousands[place] +
                        (word ? " " + word : "");
                }
            }
            num = Math.floor(num / 1000); // Move to next chunk
            place++;
        }

        return word.trim() + " Only";
    };
